@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package limasoul.client.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val base_background: DrawableResource by 
      lazy { init_base_background() }

  public val google_icon: DrawableResource by 
      lazy { init_google_icon() }

  public val ic_add: DrawableResource by 
      lazy { init_ic_add() }

  public val ic_admin_settings: DrawableResource by 
      lazy { init_ic_admin_settings() }

  public val ic_bass: DrawableResource by 
      lazy { init_ic_bass() }

  public val ic_bass_circle: DrawableResource by 
      lazy { init_ic_bass_circle() }

  public val ic_close: DrawableResource by 
      lazy { init_ic_close() }

  public val ic_drums: DrawableResource by 
      lazy { init_ic_drums() }

  public val ic_drums_circle: DrawableResource by 
      lazy { init_ic_drums_circle() }

  public val ic_guitar: DrawableResource by 
      lazy { init_ic_guitar() }

  public val ic_guitar_circle: DrawableResource by 
      lazy { init_ic_guitar_circle() }

  public val ic_home: DrawableResource by 
      lazy { init_ic_home() }

  public val ic_info: DrawableResource by 
      lazy { init_ic_info() }

  public val ic_keys: DrawableResource by 
      lazy { init_ic_keys() }

  public val ic_keys_circle: DrawableResource by 
      lazy { init_ic_keys_circle() }

  public val ic_launcher_background: DrawableResource by 
      lazy { init_ic_launcher_background() }

  public val ic_mic: DrawableResource by 
      lazy { init_ic_mic() }

  public val ic_mic_circle: DrawableResource by 
      lazy { init_ic_mic_circle() }

  public val ic_my_track_star: DrawableResource by 
      lazy { init_ic_my_track_star() }

  public val ic_not_ready: DrawableResource by 
      lazy { init_ic_not_ready() }

  public val ic_open_new: DrawableResource by 
      lazy { init_ic_open_new() }

  public val ic_optional_booked: DrawableResource by 
      lazy { init_ic_optional_booked() }

  public val ic_profile: DrawableResource by 
      lazy { init_ic_profile() }

  public val ic_ready: DrawableResource by 
      lazy { init_ic_ready() }

  public val icon_musical_note: DrawableResource by 
      lazy { init_icon_musical_note() }

  public val icon_people: DrawableResource by 
      lazy { init_icon_people() }

  public val logo: DrawableResource by 
      lazy { init_logo() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("base_background", CommonMainDrawable0.base_background)
  map.put("google_icon", CommonMainDrawable0.google_icon)
  map.put("ic_add", CommonMainDrawable0.ic_add)
  map.put("ic_admin_settings", CommonMainDrawable0.ic_admin_settings)
  map.put("ic_bass", CommonMainDrawable0.ic_bass)
  map.put("ic_bass_circle", CommonMainDrawable0.ic_bass_circle)
  map.put("ic_close", CommonMainDrawable0.ic_close)
  map.put("ic_drums", CommonMainDrawable0.ic_drums)
  map.put("ic_drums_circle", CommonMainDrawable0.ic_drums_circle)
  map.put("ic_guitar", CommonMainDrawable0.ic_guitar)
  map.put("ic_guitar_circle", CommonMainDrawable0.ic_guitar_circle)
  map.put("ic_home", CommonMainDrawable0.ic_home)
  map.put("ic_info", CommonMainDrawable0.ic_info)
  map.put("ic_keys", CommonMainDrawable0.ic_keys)
  map.put("ic_keys_circle", CommonMainDrawable0.ic_keys_circle)
  map.put("ic_launcher_background", CommonMainDrawable0.ic_launcher_background)
  map.put("ic_mic", CommonMainDrawable0.ic_mic)
  map.put("ic_mic_circle", CommonMainDrawable0.ic_mic_circle)
  map.put("ic_my_track_star", CommonMainDrawable0.ic_my_track_star)
  map.put("ic_not_ready", CommonMainDrawable0.ic_not_ready)
  map.put("ic_open_new", CommonMainDrawable0.ic_open_new)
  map.put("ic_optional_booked", CommonMainDrawable0.ic_optional_booked)
  map.put("ic_profile", CommonMainDrawable0.ic_profile)
  map.put("ic_ready", CommonMainDrawable0.ic_ready)
  map.put("icon_musical_note", CommonMainDrawable0.icon_musical_note)
  map.put("icon_people", CommonMainDrawable0.icon_people)
  map.put("logo", CommonMainDrawable0.logo)
}

internal val Res.drawable.base_background: DrawableResource
  get() = CommonMainDrawable0.base_background

private fun init_base_background(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:base_background",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/base_background.png", -1, -1),
    )
)

internal val Res.drawable.google_icon: DrawableResource
  get() = CommonMainDrawable0.google_icon

private fun init_google_icon(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:google_icon",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/google_icon.xml", -1, -1),
    )
)

internal val Res.drawable.ic_add: DrawableResource
  get() = CommonMainDrawable0.ic_add

private fun init_ic_add(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_add",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_add.xml", -1, -1),
    )
)

internal val Res.drawable.ic_admin_settings: DrawableResource
  get() = CommonMainDrawable0.ic_admin_settings

private fun init_ic_admin_settings(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_admin_settings",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_admin_settings.xml", -1, -1),
    )
)

internal val Res.drawable.ic_bass: DrawableResource
  get() = CommonMainDrawable0.ic_bass

private fun init_ic_bass(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_bass",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_bass.xml", -1, -1),
    )
)

internal val Res.drawable.ic_bass_circle: DrawableResource
  get() = CommonMainDrawable0.ic_bass_circle

private fun init_ic_bass_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_bass_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_bass_circle.xml", -1, -1),
    )
)

internal val Res.drawable.ic_close: DrawableResource
  get() = CommonMainDrawable0.ic_close

private fun init_ic_close(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_close",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_close.xml", -1, -1),
    )
)

internal val Res.drawable.ic_drums: DrawableResource
  get() = CommonMainDrawable0.ic_drums

private fun init_ic_drums(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_drums",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_drums.xml", -1, -1),
    )
)

internal val Res.drawable.ic_drums_circle: DrawableResource
  get() = CommonMainDrawable0.ic_drums_circle

private fun init_ic_drums_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_drums_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_drums_circle.xml", -1, -1),
    )
)

internal val Res.drawable.ic_guitar: DrawableResource
  get() = CommonMainDrawable0.ic_guitar

private fun init_ic_guitar(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_guitar",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_guitar.xml", -1, -1),
    )
)

internal val Res.drawable.ic_guitar_circle: DrawableResource
  get() = CommonMainDrawable0.ic_guitar_circle

private fun init_ic_guitar_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_guitar_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_guitar_circle.xml", -1, -1),
    )
)

internal val Res.drawable.ic_home: DrawableResource
  get() = CommonMainDrawable0.ic_home

private fun init_ic_home(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_home",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_home.xml", -1, -1),
    )
)

internal val Res.drawable.ic_info: DrawableResource
  get() = CommonMainDrawable0.ic_info

private fun init_ic_info(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_info",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_info.xml", -1, -1),
    )
)

internal val Res.drawable.ic_keys: DrawableResource
  get() = CommonMainDrawable0.ic_keys

private fun init_ic_keys(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_keys",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_keys.xml", -1, -1),
    )
)

internal val Res.drawable.ic_keys_circle: DrawableResource
  get() = CommonMainDrawable0.ic_keys_circle

private fun init_ic_keys_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_keys_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_keys_circle.xml", -1, -1),
    )
)

internal val Res.drawable.ic_launcher_background: DrawableResource
  get() = CommonMainDrawable0.ic_launcher_background

private fun init_ic_launcher_background(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_launcher_background",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_launcher_background.xml", -1, -1),
    )
)

internal val Res.drawable.ic_mic: DrawableResource
  get() = CommonMainDrawable0.ic_mic

private fun init_ic_mic(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_mic",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_mic.xml", -1, -1),
    )
)

internal val Res.drawable.ic_mic_circle: DrawableResource
  get() = CommonMainDrawable0.ic_mic_circle

private fun init_ic_mic_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_mic_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_mic_circle.xml", -1, -1),
    )
)

internal val Res.drawable.ic_my_track_star: DrawableResource
  get() = CommonMainDrawable0.ic_my_track_star

private fun init_ic_my_track_star(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_my_track_star",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_my_track_star.xml", -1, -1),
    )
)

internal val Res.drawable.ic_not_ready: DrawableResource
  get() = CommonMainDrawable0.ic_not_ready

private fun init_ic_not_ready(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_not_ready",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_not_ready.xml", -1, -1),
    )
)

internal val Res.drawable.ic_open_new: DrawableResource
  get() = CommonMainDrawable0.ic_open_new

private fun init_ic_open_new(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_open_new",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_open_new.xml", -1, -1),
    )
)

internal val Res.drawable.ic_optional_booked: DrawableResource
  get() = CommonMainDrawable0.ic_optional_booked

private fun init_ic_optional_booked(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_optional_booked",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_optional_booked.xml", -1, -1),
    )
)

internal val Res.drawable.ic_profile: DrawableResource
  get() = CommonMainDrawable0.ic_profile

private fun init_ic_profile(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_profile",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_profile.xml", -1, -1),
    )
)

internal val Res.drawable.ic_ready: DrawableResource
  get() = CommonMainDrawable0.ic_ready

private fun init_ic_ready(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_ready",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/ic_ready.xml", -1, -1),
    )
)

internal val Res.drawable.icon_musical_note: DrawableResource
  get() = CommonMainDrawable0.icon_musical_note

private fun init_icon_musical_note(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:icon_musical_note",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/icon_musical_note.xml", -1, -1),
    )
)

internal val Res.drawable.icon_people: DrawableResource
  get() = CommonMainDrawable0.icon_people

private fun init_icon_people(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:icon_people",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/icon_people.xml", -1, -1),
    )
)

internal val Res.drawable.logo: DrawableResource
  get() = CommonMainDrawable0.logo

private fun init_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/drawable/logo.xml", -1, -1),
    )
)
